
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

interface CopyNotificationProps {
    show: boolean;
}

const CopyNotification: React.FC<CopyNotificationProps> = ({ show }) => {
    const { t } = useTranslation();

    if (!show) return null;

    return (
        // Clears the fixed bottom action bar on a phone; back to the corner once
        // that bar is gone.
        <div className="fixed bottom-24 lg:bottom-4 right-4 glass-toast text-green-700 dark:text-green-400 px-4 py-2 flex items-center z-50">
            <FontAwesomeIcon icon={faCheck} className="mr-2" />
            {t('event.components.copyNotification.eventLinkCopied')}
        </div>
    );
};

export default CopyNotification;